import { Button } from "@/components/ui/button";

export function FavoritesBanner() {
	return (
		<div className="flex space-x-12 relative overflow-hidden rounded-xl bg-[#2A2A2A] px-6 py-8 md:px-8">
			<div className="flex items-center justify-between">
				<div className="space-y-2">
					<h2 className="text-2xl font-medium text-[#D0CAFF] md:text-3xl">
						Find your favourite vendors easily
					</h2>
					<p className="text-gray-300 font-light">
						Add them to favourites so you can easily find them next time
					</p>
				</div>
			</div>
			<div className="absolute left-1/2 transform -translate-x-1/2 top-1/2 -translate-y-1/2">
				<img src="/assets/boookmark-3d.png" alt="Bookmark 3d" />
			</div>
			<Button
				variant="secondary"
				className="absolute right-6 top-1/2 -translate-y-1/2 md:right-8"
			>
				See Favourites
			</Button>
		</div>
	);
}
